import { useEffect, useState } from "react";
import { formatDate, formatDateTimeToTime, formatTime, SweetAlertShow } from "../../../master/Master";
import { studentBatchTransferHistory } from "../../../../api/StudentDetails";
import { Pill } from "./Master";

const Skeleton = ({ w = "100%", h = "14px" }) => (
    <span
        className="placeholder"
        style={{
            width: w,
            height: h,
            display: "inline-block",
            borderRadius: "6px",
        }}
    />
);

const fmtDate = (d) =>
    d
        ? new Date(d).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        })
        : "-";

export default function TransferHistoryModal({ batch, onClose }) {
    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState([]);

    const fetchHistory = async () => {
        setLoading(true);

        try {
            const response = await studentBatchTransferHistory(batch?.id);

            if (response.data.status) {
                setRows(response.data.data || []);
            } else {
                SweetAlertShow("info", "Warning", response.data.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ||
                error?.response?.message ||
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (batch?.id) {
            fetchHistory();
        }
    }, [batch?.id]);

    return (
        <div
            className="modal d-block"
            style={{ background: "rgba(0,0,0,.5)" }}
            tabIndex={-1}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered modal-xl"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content rounded-4 border-0 overflow-hidden">
                    <div className="modal-header border-0 pb-0">
                        <div>
                            <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                                <i className="ri-history-line text-primary"></i>
                                Batch Transfer History
                            </h5>

                            <div className="d-flex flex-wrap gap-2 mt-2">
                                <Pill
                                    icon="ri-book-open-line"
                                    color="primary"
                                    label="Course"
                                    value={batch?.course?.title || "-"}
                                />

                                <Pill
                                    icon="ri-team-line"
                                    color="success"
                                    label="Current Batch"
                                    value={batch?.batch?.title || "-"}
                                />

                                <Pill
                                    icon="ri-calendar-line"
                                    color="info"
                                    label="Session"
                                    value={batch?.session_year?.session || "-"}
                                />
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        />
                    </div>

                    <div className="modal-body">
                        {loading ? (
                            <div className="placeholder-glow d-flex flex-column gap-2">
                                <Skeleton h="20px" />
                                <Skeleton h="20px" />
                                <Skeleton h="20px" />
                                <Skeleton h="20px" />
                            </div>
                        ) : rows.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>From Batch</th>
                                            <th>To Batch</th>
                                            <th>Transfer Date</th>
                                            <th>Time</th>
                                            <th>Transfer By</th>
                                            <th>Reason</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {rows.map((row, index) => {
                                            const fromBatch = row?.batch;
                                            const toBatch = rows[index + 1]?.batch;

                                            return (
                                                <tr key={row.id}>
                                                    <td>{index + 1}</td>

                                                    <td>{fromBatch?.title || "-"}</td>

                                                    <td>
                                                        {toBatch ? (
                                                            <>
                                                                {toBatch?.title}
                                                                <br />
                                                                <small className="text-muted">
                                                                    {toBatch?.course?.title}
                                                                </small>
                                                            </>
                                                        ) : (
                                                            <span className="badge bg-success">Current Batch</span>
                                                        )}
                                                    </td>

                                                    <td>{formatDate(row?.transfer_datetime)}</td>

                                                    <td>{formatDateTimeToTime(row?.transfer_datetime)}</td>

                                                    <td>{row?.transfer_by?.name || "-"}</td>
                                                    <td>{row?.reason || "-"}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <i className="ri-inbox-line fs-1 text-muted"></i>
                                <h6 className="mt-2">No Transfer History Found</h6>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer border-0">
                        <button
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                        >
                            <i className="ri-close-line me-1"></i>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}